import { p as proxyCustomElement, H, d as createEvent, h, c as Host } from './p-92c4a1ea.js';
import { i as isSameArray } from './p-d7a5de56.js';
import { Z as doWhenDefaultIsNotPrevented, a7 as KeyboardCode, ah as isAlphaNumeric, Q as stopEvent, ai as isDefined, a9 as KeydownHostEvent, ac as KeydownManager, a8 as KeydownAction, I as hasEllipsis, am as hasValue } from './p-a57042e3.js';
import { O as OnClosestFormSubmit, V as Validator } from './p-63f34a46.js';
import { h as hideElementFromAccessibilityAPI, a as accessibilityAttributes } from './p-756e7dc5.js';
import { u as useRef } from './p-e952b680.js';
import { a as ComponentUtils } from './p-de830ba7.js';
import { O as OnClosestFormReset } from './p-bc27ca19.js';
import { d as defineCustomElement$h } from './p-35b617b4.js';
import { d as defineCustomElement$g } from './p-69451510.js';
import { d as defineCustomElement$f } from './p-d7980c17.js';
import { d as defineCustomElement$e } from './p-8bd1db02.js';
import { d as defineCustomElement$d } from './p-8bfe5ab0.js';
import { d as defineCustomElement$c } from './p-0585e0e2.js';
import { d as defineCustomElement$b } from './p-25396692.js';
import { d as defineCustomElement$a } from './p-3a198e00.js';
import { d as defineCustomElement$9 } from './p-21c18302.js';
import { d as defineCustomElement$8 } from './p-7bb98ead.js';
import { d as defineCustomElement$7 } from './p-867a1c3b.js';
import { d as defineCustomElement$6 } from './p-96ee8029.js';
import { d as defineCustomElement$5 } from './p-a83b6d5f.js';
import { d as defineCustomElement$4 } from './p-106f8152.js';
import { d as defineCustomElement$3 } from './p-c5978c85.js';
import { d as defineCustomElement$2 } from './p-096bd431.js';
import { d as defineCustomElement$1 } from './p-c953c88d.js';
const baseDropdownCss = ".sc-owc-base-dropdown-h{width:inherit;display:-ms-inline-flexbox;display:inline-flex}.sc-owc-base-dropdown-h owc-input.sc-owc-base-dropdown{min-width:inherit !important;max-width:inherit !important;width:inherit !important}.sc-owc-base-dropdown-h owc-input.sc-owc-base-dropdown input.sc-owc-base-dropdown{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100%}.sc-owc-base-dropdown-h owc-menu.sc-owc-base-dropdown{-webkit-box-shadow:none;box-shadow:none}.sc-owc-base-dropdown-h owc-input.sc-owc-base-dropdown .owc-base-dropdown__clear-button.sc-owc-base-dropdown{color:inherit !important;display:none}.sc-owc-base-dropdown-h owc-input.sc-owc-base-dropdown .owc-base-dropdown__plus-text.sc-owc-base-dropdown{font-family:var(--one-typography-font-family);font-size:var(--one-typography-desktop-subtitle-1-font-size);line-height:var(--one-typography-desktop-subtitle-1-line-height);-webkit-font-kerning:var(--one-typography-desktop-subtitle-1-font-kerning);font-kerning:var(--one-typography-desktop-subtitle-1-font-kerning);font-weight:var(--one-text-font-weight-regular)}.sc-owc-base-dropdown-h owc-input.sc-owc-base-dropdown .owc-base-dropdown__menu-trigger-button.sc-owc-base-dropdown{background-color:transparent;color:inherit !important}.sc-owc-base-dropdown-h owc-menu.sc-owc-base-dropdown owc-card.sc-owc-base-dropdown .owc-card__header-wrapper.sc-owc-base-dropdown .owc-base-dropdown__menu-header.sc-owc-base-dropdown{padding:0}.sc-owc-base-dropdown-h owc-menu.sc-owc-base-dropdown .owc-base-dropdown__menu-footer.sc-owc-base-dropdown{padding:var(--one-spacing-padding-4-xs) var(--one-spacing-padding-2-xs)}.owc-base-dropdown--loading.sc-owc-base-dropdown-h owc-list-item.sc-owc-base-dropdown{visibility:hidden}.owc-base-dropdown--has-clear-button.sc-owc-base-dropdown-h owc-input.sc-owc-base-dropdown .owc-base-dropdown__clear-button.sc-owc-base-dropdown{display:-ms-flexbox;display:flex}.sc-owc-base-dropdown-h:not(.owc-base-dropdown--editing) owc-input.sc-owc-base-dropdown{cursor:default}.owc-base-dropdown--disabled.sc-owc-base-dropdown-h owc-input.sc-owc-base-dropdown .owc-base-dropdown__clear-button.sc-owc-base-dropdown{background-color:transparent}.sc-owc-base-dropdown-h:not(.owc-base-dropdown--visible) owc-flex-menu.sc-owc-base-dropdown{display:none}";
const OwcBaseDropdownStyle0 = baseDropdownCss;
var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const MENU_ITEM_LIMIT = 6;
const TAG_LIST_ITEM = 'owc-list-item';
const TOOLTIP_OFFSET = 2;
const PAGE_JUMP_OFFSET = 10;
const BaseDropdown = /*@__PURE__*/proxyCustomElement(class BaseDropdown extends H {
  constructor() {
    super();
    this.__registerHost();
    this.valueChange = createEvent(this, "valueChange", 3);
    this.visibleChange = createEvent(this, "visibleChange", 3);
    this.clickOutside = createEvent(this, "clickOutside", 3);
    this.clearClick = createEvent(this, "clearClick", 3);
    this.validityChange = createEvent(this, "validityChange", 3);
    this.itemAdd = createEvent(this, "itemAdd", 3);
    this.validator = new Validator();
    this.nativeInputRef = useRef();
    this.clearButtonRef = useRef();
    this.resetRequested = false;
    this.focusedProgrammatically = false;
    this.updateDropdownFocus = () => {
      var _a;
      (_a = this.listRef) === null || _a === void 0 ? void 0 : _a.getKeydownManager().then(manager => {
        if (!this.focusedProgrammatically) {
          manager.clearFocus();
          manager.setCurrentItem(manager.getActualSelectedItem() || manager.getFirstItem(), null, false);
        }
        this.focusedProgrammatically = false;
        manager.scrollToCurrentElement();
      });
    };
    this.focusSelectedItemInList = props => {
      var _a;
      (_a = this.listRef) === null || _a === void 0 ? void 0 : _a.getKeydownManager().then(manager => {
        manager.clearFocus();
        manager.setCurrentItem(manager.getActualSelectedItem() || manager.getFirstItem(), props, true);
      });
    };
    this.focusInputElement = () => {
      var _a, _b;
      if (!this.disabled && !this.focused) {
        (_b = (_a = this.nativeInputRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
        this.focused = true;
      }
    };
    this.blurInputElement = () => {
      var _a, _b;
      if (this.focused) {
        (_b = (_a = this.nativeInputRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.blur();
        this.focused = false;
      }
    };
    this.getTriggers = () => {
      var _a;
      return Array.isArray(this.validationTrigger) ? this.validationTrigger : ((_a = this.validationTrigger) === null || _a === void 0 ? void 0 : _a.split(',').map(item => item.trim())) || [];
    };
    this.hasTrigger = trigger => this.getTriggers().includes(trigger);
    this.isVisible = () => !this.disabled && this.visible;
    this.isSearchable = () => (this.searchable || this.editable) && !this.disabled;
    this.isSearchingNow = () => this.isSearchable() && this.visible;
    this.isSelectOnApplyVisible = () => this.multiple && this.showApplyButton;
    this.getListItems = () => {
      var _a;
      return Array.from(((_a = this.listRef) === null || _a === void 0 ? void 0 : _a.querySelectorAll(TAG_LIST_ITEM)) || []);
    };
    this.setValue = newValue => {
      if (!isSameArray(newValue, this.value)) {
        if (!this.controlled) {
          this.value = [...newValue];
        } else {
          this.valueChange.emit(newValue);
        }
      }
    };
    this.setValidationOptions = () => {
      this.validator.type('select').minLength(this.multiple ? this.minlength : undefined).maxLength(this.multiple ? this.maxlength : undefined).notOneOf(this.notSelectableValues).oneOf(this.selectableValues);
      this.required ? this.validator.required() : this.validator.optional();
    };
    this.isClearButtonTriggered = element => {
      var _a, _b;
      return (_b = (_a = this.clearButtonRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.contains(element);
    };
    this.onInputClicked = (ev, originalHandler) => {
      originalHandler === null || originalHandler === void 0 ? void 0 : originalHandler(ev);
      doWhenDefaultIsNotPrevented(ev, () => this.visible = true);
    };
    this.onInputFocused = (ev, originalHandler) => {
      originalHandler === null || originalHandler === void 0 ? void 0 : originalHandler(ev);
      doWhenDefaultIsNotPrevented(ev, () => this.hostElement.dispatchEvent(new KeyboardEvent('focus')));
    };
    this.onInputBlurred = (ev, originalHandler) => {
      originalHandler === null || originalHandler === void 0 ? void 0 : originalHandler(ev);
      doWhenDefaultIsNotPrevented(ev, () => this.hostElement.dispatchEvent(new KeyboardEvent('blur')));
    };
    this.onInputKeyDown = (ev, originalHandler) => {
      originalHandler === null || originalHandler === void 0 ? void 0 : originalHandler(ev);
      const isAddingAllowed = this.editable && (this.addItemOnMatch ? true : this.allItemsHidden);
      if (this.isSearchingNow() && isAddingAllowed && [KeyboardCode.Enter, KeyboardCode.NumpadEnter].includes(ev.code)) {
        this.itemAdd.emit(ev.target.value);
        this.visible = false;
      }
      if (this.isSearchable() && (ev.key.length === 1 && isAlphaNumeric(ev.key) || [KeyboardCode.Backspace, KeyboardCode.Delete].includes(ev.code))) {
        this.visible = true;
      }
      return true;
    };
    this.onInputValueChanged = (ev, originalHandler) => {
      originalHandler === null || originalHandler === void 0 ? void 0 : originalHandler(ev);
      doWhenDefaultIsNotPrevented(ev, () => this.isSearchingNow() && (this.searchTerm = ev.detail));
    };
    this.onInputMouseOut = (ev, originalHandler) => {
      originalHandler === null || originalHandler === void 0 ? void 0 : originalHandler(ev);
      doWhenDefaultIsNotPrevented(ev, () => this.tooltipVisible = false);
    };
    this.onInputMouseOver = (ev, originalHandler) => {
      originalHandler === null || originalHandler === void 0 ? void 0 : originalHandler(ev);
      doWhenDefaultIsNotPrevented(ev, () => this.shouldTooltipRender() && (this.tooltipVisible = true));
    };
    this.onMenuClickOutside = (ev, originalHandler) => {
      originalHandler === null || originalHandler === void 0 ? void 0 : originalHandler(ev);
      doWhenDefaultIsNotPrevented(ev, () => {
        this.focused = false;
        this.visible = false;
        this.clickOutside.emit();
      });
    };
    this.onClearButtonClicked = (ev, originalHandler) => {
      originalHandler === null || originalHandler === void 0 ? void 0 : originalHandler(ev);
      doWhenDefaultIsNotPrevented(ev, () => {
        var _a, _b;
        stopEvent(ev);
        if (this.isSearchingNow()) {
          this.searchTerm = undefined;
          (_a = this.inputRef) === null || _a === void 0 ? void 0 : _a.focus();
        } else {
          this.setValue([]);
          this.copyValueToActiveSelections();
          this.clearClick.emit();
          (_b = this.inputRef) === null || _b === void 0 ? void 0 : _b.focus();
          !this.disableValidation && this.hasTrigger('blur') && this.validate();
        }
      });
    };
    this.onMenuTriggerButtonClicked = (ev, originalHandler) => {
      originalHandler === null || originalHandler === void 0 ? void 0 : originalHandler(ev);
      doWhenDefaultIsNotPrevented(ev, () => {
        var _a;
        stopEvent(ev);
        this.visible = !this.visible;
        this.visible && ((_a = this.inputRef) === null || _a === void 0 ? void 0 : _a.focus());
      });
    };
    this.onMenuTriggerButtonMouseDown = (ev, originalHandler) => {
      originalHandler === null || originalHandler === void 0 ? void 0 : originalHandler(ev);
      ev.preventDefault();
    };
    this.onApplyButtonClicked = () => {
      this.copyActiveSelectionsToValue();
      this.visible = false;
    };
    this.onSelectAllClicked = () => {
      if (this.selectAllCheckboxState === true) {
        if (this.isSelectOnApplyVisible()) {
          this.activeSelections = [];
        } else {
          this.setValue([]);
        }
        this.selectAllCheckboxState = false;
      } else {
        const allItemValues = this.getSelectableListItems().map(item => item.value).filter(isDefined);
        if (this.isSelectOnApplyVisible()) {
          this.activeSelections = [...allItemValues];
        } else {
          this.setValue(allItemValues);
        }
        this.selectAllCheckboxState = true;
      }
    };
    this.onListSelectedChanged = (ev, originalHandler) => {
      stopEvent(ev);
      if (this.isSelectOnApplyVisible()) {
        this.activeSelections = [...(ev.detail || [])];
      } else {
        this.setValue(ev.detail);
      }
      originalHandler === null || originalHandler === void 0 ? void 0 : originalHandler(ev);
    };
    this.component = new ComponentUtils(this, {
      patchFocusMethod: () => this.focusInputElement(),
      patchBlurMethod: () => this.blurInputElement()
    }).withKeydownManagerLazy(() => this.inputRef, {
      scroll: {
        container: () => this.listRef
      },
      hostEventHandlers: {
        [KeydownHostEvent.FOCUS]: () => {
          this.focused = true;
        }
      },
      keydownHandlers: [{
        key: [KeyboardCode.Tab, {
          code: KeyboardCode.Tab,
          shift: true
        }],
        handler: () => {
          !this.visible && !this.disableValidation && this.hasTrigger('blur') && this.validate();
          this.visible && (this.visible = false);
          this.focused = false;
        },
        preventDefault: false
      }, {
        key: KeydownManager.DefaultKeys[KeydownAction.CLOSE],
        disabled: () => !this.visible,
        handler: () => this.visible = false
      }, {
        key: [KeyboardCode.ArrowDown],
        handler: props => {
          var _a;
          if (this.visible) {
            (_a = this.listRef) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new KeyboardEvent(props.event.type, props.event));
          } else {
            this.focusedProgrammatically = true;
            this.visible = true;
            this.focusSelectedItemInList(props);
          }
        },
        disabled: ({
          event
        }) => this.isClearButtonTriggered(event.target)
      }, {
        key: [{
          code: KeyboardCode.ArrowDown,
          alt: true
        }],
        handler: () => {
          var _a;
          this.focusedProgrammatically = true;
          this.visible = true;
          (_a = this.listRef) === null || _a === void 0 ? void 0 : _a.getKeydownManager().then(manager => {
            manager.clearFocus();
            manager.setStartIndex(-1);
            manager.scrollToFirstElement();
          });
        },
        disabled: ({
          event
        }) => this.visible || this.isClearButtonTriggered(event.target)
      }, {
        key: [KeyboardCode.ArrowUp],
        handler: props => {
          var _a, _b;
          if (this.visible) {
            (_a = this.listRef) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new KeyboardEvent(props.event.type, props.event));
          } else {
            this.focusedProgrammatically = true;
            this.visible = true;
            (_b = this.listRef) === null || _b === void 0 ? void 0 : _b.getKeydownManager().then(manager => manager.setCurrentItem(manager.getLastItem(), props));
          }
        },
        disabled: ({
          event
        }) => this.isClearButtonTriggered(event.target)
      }, {
        key: [KeyboardCode.ArrowRight, KeyboardCode.ArrowLeft],
        handler: props => {
          var _a;
          if (this.visible) {
            (_a = this.listRef) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new KeyboardEvent(props.event.type, props.event));
          }
        },
        preventDefault: !this.isSearchable(),
        disabled: () => this.visible ? this.isSearchable() : true
      }, {
        key: [KeyboardCode.Home],
        handler: props => {
          var _a;
          this.focusedProgrammatically = true;
          this.visible = true;
          (_a = this.listRef) === null || _a === void 0 ? void 0 : _a.getKeydownManager().then(manager => manager.setCurrentItem(manager.getFirstItem(), props));
        },
        disabled: ({
          event
        }) => this.isSearchable() || this.isClearButtonTriggered(event.target)
      }, {
        key: [KeyboardCode.End],
        handler: props => {
          var _a;
          this.focusedProgrammatically = true;
          this.visible = true;
          (_a = this.listRef) === null || _a === void 0 ? void 0 : _a.getKeydownManager().then(manager => manager.setCurrentItem(manager.getLastItem(), props));
        },
        disabled: ({
          event
        }) => this.isSearchable() || this.isClearButtonTriggered(event.target)
      }, {
        key: [KeyboardCode.PageUp],
        handler: props => {
          var _a;
          (_a = this.listRef) === null || _a === void 0 ? void 0 : _a.getKeydownManager().then(manager => manager.setCurrentItem(manager.getItem(manager.getCurrentIndex() - PAGE_JUMP_OFFSET, false), props));
        },
        disabled: () => !this.visible
      }, {
        key: [KeyboardCode.PageDown],
        handler: props => {
          var _a;
          (_a = this.listRef) === null || _a === void 0 ? void 0 : _a.getKeydownManager().then(manager => manager.setCurrentItem(manager.getItem(manager.getCurrentIndex() + PAGE_JUMP_OFFSET, false), props));
        },
        disabled: () => !this.visible
      }, {
        key: [KeyboardCode.Enter, KeyboardCode.NumpadEnter],
        handler: props => {
          var _a;
          if (this.visible) {
            (_a = this.listRef) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new KeyboardEvent(props.event.type, props.event));
            this.focused = false;
            const shouldKeepMenuOpen = this.editable ? this.addItemOnMatch ? true : this.allItemsHidden : this.multiple;
            !shouldKeepMenuOpen && (this.visible = false);
            this.hostElement.focus();
          } else {
            this.focusedProgrammatically = true;
            this.visible = true;
            this.focusSelectedItemInList(props);
          }
        },
        disabled: ({
          event
        }) => this.isClearButtonTriggered(event.target)
      }, {
        key: [KeyboardCode.Space],
        handler: props => {
          var _a;
          if (this.visible) {
            (_a = this.listRef) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new KeyboardEvent(props.event.type, props.event));
            this.focused = false;
            const shouldKeepMenuOpen = this.searchable || (this.editable ? this.addItemOnMatch ? true : this.allItemsHidden : this.multiple);
            !shouldKeepMenuOpen && (this.visible = false);
            this.hostElement.focus();
          } else {
            this.focusedProgrammatically = true;
            this.visible = true;
            this.focusSelectedItemInList(props);
          }
        },
        preventDefault: !this.isSearchable(),
        disabled: ({
          event
        }) => this.isSearchable() || this.isClearButtonTriggered(event.target)
      }, {
        key: [{
          code: KeyboardCode.ArrowUp,
          alt: true
        }],
        handler: props => {
          var _a;
          (_a = this.listRef) === null || _a === void 0 ? void 0 : _a.getKeydownManager().then(manager => {
            manager.DefaultKeydownHandler[KeydownAction.SELECT](props);
            this.focused = false;
            this.hostElement.focus();
          });
        },
        disabled: ({
          event
        }) => !this.visible || this.isClearButtonTriggered(event.target)
      }]
    });
    this.visible = false;
    this.validity = {
      state: 'valid'
    };
    this.disabled = false;
    this.label = undefined;
    this.limit = MENU_ITEM_LIMIT;
    this.name = undefined;
    this.placeholder = undefined;
    this.required = false;
    this.value = [];
    this.variant = 'filled';
    this.size = 'medium';
    this.rounded = false;
    this.searchable = false;
    this.editable = false;
    this.notFoundText = 'Not Found';
    this.noClearIcon = false;
    this.disableValidation = false;
    this.multiple = false;
    this.selectAllText = 'All';
    this.hideSelectAll = false;
    this.addItemOnMatch = false;
    this.showApplyButton = false;
    this.applyButtonText = 'Apply';
    this.minlength = undefined;
    this.maxlength = undefined;
    this.notSelectableValues = [];
    this.selectableValues = [];
    this.controlled = false;
    this.validationTrigger = 'input, blur';
    this.controlledValidity = false;
    this.inputProps = undefined;
    this.clearButtonProps = undefined;
    this.menuTriggerButtonProps = undefined;
    this.menuProps = undefined;
    this.tooltipProps = undefined;
    this.selectAllCheckboxState = false;
    this.selectedItemTexts = [];
    this.searchTerm = undefined;
    this.allItemsHidden = undefined;
    this.activeSelections = [];
    this.tooltipVisible = false;
    this.focused = false;
    this.inputRef = undefined;
    this.listRef = undefined;
    this.loading = true;
  }
  onValueChanged(newValue, oldValue) {
    if (!isSameArray(newValue, oldValue)) {
      this.copyValueToActiveSelections();
      !this.controlled && this.valueChange.emit(newValue);
      !this.disableValidation && this.hasTrigger('input') && this.validate();
    }
  }
  onDisabledChanged() {
    this.visible = false;
  }
  onVisibleChanged(newValue, oldValue) {
    this.searchTerm = undefined;
    this.tooltipVisible = false;
    this.copyValueToActiveSelections();
    !this.disableValidation && !newValue && this.hasTrigger('blur') && this.validate();
    if (!!newValue !== !!oldValue) {
      this.visibleChange.emit(!!newValue);
      this.visible && this.updateDropdownFocus();
    }
  }
  onValidityChange(newValue, oldValue) {
    if ((newValue === null || newValue === void 0 ? void 0 : newValue.state) !== (oldValue === null || oldValue === void 0 ? void 0 : oldValue.state) || !isSameArray(oldValue === null || oldValue === void 0 ? void 0 : oldValue.type, newValue === null || newValue === void 0 ? void 0 : newValue.type)) {
      !this.controlledValidity && this.validityChange.emit(newValue);
      this.inputRef && (this.inputRef.validity = newValue);
    }
  }
  onValidatorParamsChange() {
    this.setValidationOptions();
    !this.disableValidation && this.validate();
  }
  async onSearchTermChanged() {
    var _a;
    // TODO: debounce should be implemented for performance improvement
    const searchableItems = this.getSearchableListItems();
    const searchTerm = (this.searchTerm || '').toLowerCase();
    let hiddenCount = 0;
    let positionIndex = 0;
    for (const item of searchableItems) {
      let hide = false;
      if (searchTerm) {
        const searchKey = item.searchKey || (await item.getTextContent());
        hide = !searchKey.toLowerCase().includes(searchTerm);
      }
      item.hidden = hide;
      if (!hide) {
        positionIndex += 1;
        item.ariaPosInSet = `${positionIndex}`;
      } else {
        hiddenCount += 1;
      }
    }
    this.getListItems().forEach(el => {
      el.updateInternalStates();
      el.ariaSetSize = `${searchableItems.length - hiddenCount}`;
    });
    this.allItemsHidden = hiddenCount === searchableItems.length;
    (_a = this.listRef) === null || _a === void 0 ? void 0 : _a.getKeydownManager().then(manager => {
      manager.clearFocus();
      manager.setStartIndex(-1);
    });
  }
  onClosestFormReset() {
    if (!this.disableValidation) {
      this.resetRequested = !(isSameArray([], this.value) || !this.value);
      if (this.controlledValidity) {
        this.validityChange.emit({
          state: 'valid'
        });
      } else {
        this.validity = {
          state: 'valid'
        };
      }
      this.setValue([]);
    }
  }
  onClosestFormSubmit() {
    this.resetRequested = false;
    !this.disableValidation && this.validate();
  }
  /** Triggers the validation */
  validate() {
    var _a, _b;
    if (this.resetRequested && this.hasTrigger('input')) {
      this.resetRequested = false;
      return Promise.resolve({
        state: 'valid'
      });
    }
    const validationResult = this.validator.validate(this.activeSelections);
    let newValidity;
    if (validationResult === null || validationResult === void 0 ? void 0 : validationResult.length) {
      newValidity = {
        state: 'error',
        type: validationResult
      };
    } else {
      newValidity = {
        state: 'valid'
      };
    }
    if ((newValidity === null || newValidity === void 0 ? void 0 : newValidity.state) !== ((_a = this.validity) === null || _a === void 0 ? void 0 : _a.state) || !isSameArray((_b = this.validity) === null || _b === void 0 ? void 0 : _b.type, newValidity.type)) {
      if (!this.controlledValidity) {
        this.validity = newValidity;
      } else {
        this.validityChange.emit(newValidity);
      }
    }
    return Promise.resolve(newValidity);
  }
  componentDidLoad() {
    this.updateSelectedItemTexts();
    this.setValidationOptions();
    this.onValidityChange();
    this.loading = false;
  }
  componentWillLoad() {
    this.copyValueToActiveSelections();
  }
  componentWillRender() {
    this.visible && (this.selectAllCheckboxState = this.getSelectAllCheckboxState(this.getListItems()));
    this.updateSelectedItemTexts();
  }
  shouldTooltipRender() {
    if (this.multiple && this.selectedItemTexts.length > 1) {
      return true;
    } else {
      return hasEllipsis(this.nativeInputRef.current);
    }
  }
  getSelectableListItems(list) {
    return (list || this.getListItems()).filter(it => it.selectable);
  }
  getSelectedListItems() {
    var _a;
    const values = this.value || [];
    return values.length ? Array.from(((_a = this.listRef) === null || _a === void 0 ? void 0 : _a.querySelectorAll(values.map(v => `${TAG_LIST_ITEM}[value="${v}"]`).join(', '))) || []) : [];
  }
  getSearchableListItems(list) {
    return (list || this.getListItems()).filter(it => it.leaf && hasValue(it.value));
  }
  copyValueToActiveSelections() {
    !isSameArray(this.activeSelections, this.value) && (this.activeSelections = [...this.value].filter(isDefined));
  }
  copyActiveSelectionsToValue() {
    !isSameArray(this.activeSelections, this.value) && this.setValue([...this.activeSelections].filter(isDefined));
  }
  async updateSelectedItemTexts() {
    return Promise.all(this.getSelectedListItems().map(item => item.getTextContent())).then(texts => !isSameArray(texts, this.selectedItemTexts) && (this.selectedItemTexts = [...texts]));
  }
  getSelectAllCheckboxState(items) {
    var _a, _b;
    const selectableItems = this.getSelectableListItems(items);
    const selectedItemsLength = (_b = (_a = selectableItems.filter(item => hasValue(item.value) && (this.activeSelections || []).includes(item.value))) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
    if (selectableItems.length) {
      if (selectedItemsLength >= selectableItems.length) {
        return true;
      } else {
        return selectedItemsLength === 0 ? false : 'indeterminate';
      }
    } else {
      return false;
    }
  }
  isSelectedAll() {
    var _a, _b, _c;
    const selectableItems = this.getSelectableListItems();
    const selectedItemsLength = this.showApplyButton ? (_a = this.value) === null || _a === void 0 ? void 0 : _a.length : (_c = (_b = selectableItems.filter(item => hasValue(item.value) && (this.value || []).includes(item.value))) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
    if (selectableItems.length && selectedItemsLength >= selectableItems.length) {
      return true;
    } else {
      return false;
    }
  }
  getInputValue() {
    if (this.isSearchingNow()) {
      return this.searchTerm;
    } else {
      if (this.multiple && this.isSelectedAll()) {
        return this.selectAllText || 'All';
      }
      return this.selectedItemTexts[0];
    }
  }
  getInputTooltipText() {
    return (this.selectedItemTexts || []).join(', ');
  }
  getMoreItemsText() {
    const selectedOptionCount = (this.value || []).length;
    if (this.multiple && !this.isSearchingNow() && selectedOptionCount > 1 && !this.isSelectedAll()) {
      return `+${this.value.length - 1}`;
    }
    return undefined;
  }
  getInputElement(hostClasses, inputValue) {
    const plusText = this.getMoreItemsText();
    const _a = this.inputProps || {},
      {
        ref: inputRef
      } = _a,
      _b = _a.nativeInputProps,
      _c = _b === void 0 ? {} : _b,
      {
        ref: nativeInputRef = undefined
      } = _c,
      nativeInputProps = __rest(_c, ["ref"]),
      {
        onfocus: originalOnInputFocus,
        onblur: originalOnInputBlur,
        onclick: originalOnInputClick,
        onValueChange: originalOnInputValueChange,
        onmouseout: originalOnInputMouseOut,
        onmouseover: originalOnInputMouseOver,
        onkeydown: originalOnInputKeyDown
      } = _a,
      inputProps = __rest(_a, ["ref", "nativeInputProps", "onfocus", "onblur", "onclick", "onValueChange", "onmouseout", "onmouseover", "onkeydown"]);
    const _d = this.clearButtonProps || {},
      {
        className: clearButtonClassName,
        onclick: originalClearButtonClick
      } = _d,
      clearButtonProps = __rest(_d, ["className", "onclick"]);
    const _e = this.menuTriggerButtonProps || {},
      {
        className: menuTriggerButtonClassName,
        onclick: originalMenuTriggerButtonClick,
        onmousedown: originalMenuTriggerButtonMouseDown
      } = _e,
      menuTriggerButtonProps = __rest(_e, ["className", "onclick", "onmousedown"]);
    const menuTriggerButtonClasses = this.component.getChildBemClasses('menu-trigger-button', hostClasses, {}, menuTriggerButtonClassName);
    const clearButtonClasses = this.component.getChildBemClasses('clear-button', hostClasses, {}, clearButtonClassName);
    const plusTextClasses = this.component.getChildBemClasses('plus-text', hostClasses);
    return h("owc-input", Object.assign({
      ref: el => {
        this.inputRef = el;
        inputRef === null || inputRef === void 0 ? void 0 : inputRef(el);
      },
      disabled: this.disabled,
      label: this.label,
      name: this.name,
      placeholder: this.placeholder,
      required: this.required,
      variant: this.variant,
      disableValidation: true,
      size: this.size,
      rounded: this.rounded,
      validity: this.validity,
      noClearIcon: true,
      nativeInputProps: Object.assign(Object.assign(Object.assign({}, nativeInputProps), {
        readOnly: !this.isSearchable(),
        ref: el => this.nativeInputRef(el, [nativeInputRef]),
        role: 'combobox'
      }), accessibilityAttributes({
        autocomplete: this.isSearchable() ? 'list' : 'none',
        placeholder: this.placeholder
      }))
    }, inputProps, {
      value: inputValue,
      focusedView: this.isVisible(),
      onFocus: e => this.onInputFocused(e, originalOnInputFocus),
      onBlur: e => this.onInputBlurred(e, originalOnInputBlur),
      onClick: e => this.onInputClicked(e, originalOnInputClick),
      onValueChange: e => this.onInputValueChanged(e, originalOnInputValueChange),
      onMouseOut: e => this.onInputMouseOut(e, originalOnInputMouseOut),
      onMouseOver: e => this.onInputMouseOver(e, originalOnInputMouseOver),
      onKeyDown: e => this.onInputKeyDown(e, originalOnInputKeyDown)
    }), h("slot", {
      name: "assistive-text"
    }), h("slot", {
      name: "prefix"
    }), h("div", {
      slot: "suffix"
    }, h("slot", {
      name: "suffix"
    }), plusText ? h("span", Object.assign({
      class: plusTextClasses
    }, hideElementFromAccessibilityAPI()), plusText) : null, h("owc-icon-button", Object.assign({
      ref: this.clearButtonRef,
      class: clearButtonClasses,
      alt: "clear",
      icon: "circle_clear",
      family: "outlined",
      disableRipple: true,
      disabled: this.disabled,
      alternate: true,
      variant: "inner",
      size: "small"
    }, clearButtonProps, {
      onClick: e => this.onClearButtonClicked(e, originalClearButtonClick)
    })), h("owc-icon-button", Object.assign({
      class: menuTriggerButtonClasses,
      icon: this.isVisible() ? 'caret_up' : 'caret_down',
      family: "filled",
      disableRipple: true,
      disabled: this.disabled,
      alternate: true,
      variant: "inner",
      size: "small"
    }, menuTriggerButtonProps, {
      tabIndex: -1,
      onClick: e => this.onMenuTriggerButtonClicked(e, originalMenuTriggerButtonClick),
      onMouseDown: e => this.onMenuTriggerButtonMouseDown(e, originalMenuTriggerButtonMouseDown)
    }, hideElementFromAccessibilityAPI()))));
  }
  getInputTooltipElement(hostClasses) {
    var _a, _b, _c;
    if (!this.shouldTooltipRender()) {
      return null;
    } else {
      const _d = this.tooltipProps || {},
        {
          style: tooltipStyle,
          className: tooltipClassName
        } = _d,
        tooltipProps = __rest(_d, ["style", "className"]);
      const tooltipClasses = this.component.getChildBemClasses('input-tooltip', hostClasses, {}, tooltipClassName);
      const tooltipContent = this.getInputTooltipText();
      const width = ((_b = (_a = this.inputRef) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.width) || ((_c = this.hostElement.getBoundingClientRect()) === null || _c === void 0 ? void 0 : _c.width) || 0;
      return h("owc-tooltip", Object.assign({
        class: tooltipClasses,
        style: Object.assign({
          maxWidth: `${width}px`
        }, tooltipStyle),
        placement: "top",
        offset: [0, TOOLTIP_OFFSET],
        disableTriggers: true,
        leaveDuration: 0
      }, tooltipProps, {
        visible: this.tooltipVisible && !!tooltipContent && !this.isVisible(),
        anchor: this.inputRef
      }), tooltipContent);
    }
  }
  getMenuElement(hostClasses) {
    const menuFooterClasses = this.component.getChildBemClasses('menu-footer', hostClasses);
    const _a = this.menuProps || {},
      _b = _a.listProps,
      _c = _b === void 0 ? {} : _b,
      {
        onSelectedChange = undefined
      } = _c,
      listProps = __rest(_c, ["onSelectedChange"]),
      {
        onClickOutside
      } = _a,
      menuProps = __rest(_a, ["listProps", "onClickOutside"]);
    return h("owc-menu", Object.assign({
      limit: this.limit,
      position: "bottom",
      trigger: "manual",
      autoCloseOnSelection: !this.multiple,
      anchorWidth: true,
      noKeydownManager: true
    }, menuProps, {
      listProps: Object.assign(Object.assign(Object.assign({
        noDefaultBlurHandler: true,
        selected: this.activeSelections,
        multiple: this.multiple,
        showSelectorControl: this.multiple,
        notFocusable: true,
        onSelectedChange: ev => this.onListSelectedChanged(ev, onSelectedChange),
        ref: el => this.listRef = el,
        hostRole: 'listbox'
      }, accessibilityAttributes({
        required: this.required,
        readonly: !this.isSearchingNow(),
        label: this.label
      })), listProps), {
        notTabbable: true
      }),
      usage: "dropdown",
      preventOverflow: true,
      anchor: this.inputRef,
      visible: this.isVisible(),
      onVisibleChange: e => this.visible = e.detail,
      onFocusin: () => this.nativeInputRef.current.focus(),
      onClickOutside: e => this.onMenuClickOutside(e, onClickOutside)
    }), h("slot", null), this.visible ? this.getMenuHeaderElement(hostClasses, listProps === null || listProps === void 0 ? void 0 : listProps.size) : null, this.visible && this.isSelectOnApplyVisible() ? h("owc-component-footer", {
      slot: "footer",
      class: menuFooterClasses,
      onClick: stopEvent
    }, h("owc-button", {
      slot: "suffix",
      onClick: this.onApplyButtonClicked
    }, this.applyButtonText || 'Apply')) : null);
  }
  getMenuHeaderElement(hostClasses, listSize) {
    if (this.isSearchingNow()) {
      return this.searchTerm && this.allItemsHidden && this.notFoundText ? h("owc-component-header", {
        slot: "header"
      }, h("owc-typography", null, this.notFoundText || 'Not Found')) : null;
    } else {
      return this.multiple && !this.hideSelectAll ? h("owc-list-item", {
        slot: "header",
        class: this.component.getChildBemClasses('menu-header', hostClasses),
        showSelectorControl: true,
        multiple: true,
        managedCheckboxState: true,
        size: listSize || 'medium',
        checkboxState: this.selectAllCheckboxState,
        onClick: this.onSelectAllClicked
      }, this.selectAllText || 'All') : null;
    }
  }
  render() {
    const inputValue = this.getInputValue();
    const hostClasses = this.component.getHostBemClasses({
      'has-clear-button': !this.noClearIcon && !this.disabled && !!inputValue,
      editing: this.isSearchingNow(),
      disabled: this.disabled,
      loading: this.loading,
      visible: this.isVisible()
    });
    return h(Host, {
      key: '522888b68891fd6987a56df98bd7f94d68896430',
      class: hostClasses,
      tabIndex: this.disabled ? -1 : this.component.getInitialTabIndex()
    }, this.getInputElement(hostClasses, inputValue), this.getInputTooltipElement(hostClasses), this.getMenuElement(hostClasses));
  }
  get hostElement() {
    return this;
  }
  static get watchers() {
    return {
      "value": ["onValueChanged"],
      "disabled": ["onDisabledChanged"],
      "visible": ["onVisibleChanged"],
      "validity": ["onValidityChange"],
      "multiple": ["onValidatorParamsChange"],
      "minlength": ["onValidatorParamsChange"],
      "maxlength": ["onValidatorParamsChange"],
      "required": ["onValidatorParamsChange"],
      "notSelectableValues": ["onValidatorParamsChange"],
      "selectableValues": ["onValidatorParamsChange"],
      "searchTerm": ["onSearchTermChanged"]
    };
  }
  static get style() {
    return OwcBaseDropdownStyle0;
  }
}, [6, "owc-base-dropdown", {
  "visible": [1028],
  "validity": [16],
  "disabled": [4],
  "label": [1],
  "limit": [2],
  "name": [1],
  "placeholder": [1],
  "required": [4],
  "value": [16],
  "variant": [1],
  "size": [1],
  "rounded": [4],
  "searchable": [4],
  "editable": [4],
  "notFoundText": [1, "not-found-text"],
  "noClearIcon": [4, "no-clear-icon"],
  "disableValidation": [4, "disable-validation"],
  "multiple": [4],
  "selectAllText": [1, "select-all-text"],
  "hideSelectAll": [4, "hide-select-all"],
  "addItemOnMatch": [4, "add-item-on-match"],
  "showApplyButton": [4, "show-apply-button"],
  "applyButtonText": [1, "apply-button-text"],
  "minlength": [514],
  "maxlength": [514],
  "notSelectableValues": [16],
  "selectableValues": [16],
  "controlled": [516],
  "validationTrigger": [513, "validation-trigger"],
  "controlledValidity": [516, "controlled-validity"],
  "inputProps": [16],
  "clearButtonProps": [16],
  "menuTriggerButtonProps": [16],
  "menuProps": [16],
  "tooltipProps": [16],
  "selectAllCheckboxState": [32],
  "selectedItemTexts": [32],
  "searchTerm": [32],
  "allItemsHidden": [32],
  "activeSelections": [32],
  "tooltipVisible": [32],
  "focused": [32],
  "inputRef": [32],
  "listRef": [32],
  "loading": [32],
  "validate": [64]
}, undefined, {
  "value": ["onValueChanged"],
  "disabled": ["onDisabledChanged"],
  "visible": ["onVisibleChanged"],
  "validity": ["onValidityChange"],
  "multiple": ["onValidatorParamsChange"],
  "minlength": ["onValidatorParamsChange"],
  "maxlength": ["onValidatorParamsChange"],
  "required": ["onValidatorParamsChange"],
  "notSelectableValues": ["onValidatorParamsChange"],
  "selectableValues": ["onValidatorParamsChange"],
  "searchTerm": ["onSearchTermChanged"]
}]);
__decorate([OnClosestFormReset()], BaseDropdown.prototype, "onClosestFormReset", null);
__decorate([OnClosestFormSubmit()], BaseDropdown.prototype, "onClosestFormSubmit", null);
function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["owc-base-dropdown", "owc-button", "owc-card", "owc-checkbox", "owc-component-footer", "owc-component-header", "owc-divider", "owc-focus-trap", "owc-icon", "owc-icon-button", "owc-input", "owc-list", "owc-list-item", "owc-menu", "owc-popover", "owc-radio", "owc-tooltip", "owc-typography"];
  components.forEach(tagName => {
    switch (tagName) {
      case "owc-base-dropdown":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, BaseDropdown);
        }
        break;
      case "owc-button":
        if (!customElements.get(tagName)) {
          defineCustomElement$h();
        }
        break;
      case "owc-card":
        if (!customElements.get(tagName)) {
          defineCustomElement$g();
        }
        break;
      case "owc-checkbox":
        if (!customElements.get(tagName)) {
          defineCustomElement$f();
        }
        break;
      case "owc-component-footer":
        if (!customElements.get(tagName)) {
          defineCustomElement$e();
        }
        break;
      case "owc-component-header":
        if (!customElements.get(tagName)) {
          defineCustomElement$d();
        }
        break;
      case "owc-divider":
        if (!customElements.get(tagName)) {
          defineCustomElement$c();
        }
        break;
      case "owc-focus-trap":
        if (!customElements.get(tagName)) {
          defineCustomElement$b();
        }
        break;
      case "owc-icon":
        if (!customElements.get(tagName)) {
          defineCustomElement$a();
        }
        break;
      case "owc-icon-button":
        if (!customElements.get(tagName)) {
          defineCustomElement$9();
        }
        break;
      case "owc-input":
        if (!customElements.get(tagName)) {
          defineCustomElement$8();
        }
        break;
      case "owc-list":
        if (!customElements.get(tagName)) {
          defineCustomElement$7();
        }
        break;
      case "owc-list-item":
        if (!customElements.get(tagName)) {
          defineCustomElement$6();
        }
        break;
      case "owc-menu":
        if (!customElements.get(tagName)) {
          defineCustomElement$5();
        }
        break;
      case "owc-popover":
        if (!customElements.get(tagName)) {
          defineCustomElement$4();
        }
        break;
      case "owc-radio":
        if (!customElements.get(tagName)) {
          defineCustomElement$3();
        }
        break;
      case "owc-tooltip":
        if (!customElements.get(tagName)) {
          defineCustomElement$2();
        }
        break;
      case "owc-typography":
        if (!customElements.get(tagName)) {
          defineCustomElement$1();
        }
        break;
    }
  });
}
export { BaseDropdown as B, defineCustomElement as d };